import * as React from 'react';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

let styles = require('./FlightCard.scss');
let classNames = require('classnames');

/**
 * collection to specify the props for individual detail lines in the card.
 */
export interface DetailsLineProps {
    detailsData: TxpDataRow;
    txpStyle?: TxpStyle;
    isFlightCardLine?: boolean;
    isEditableEntity?: boolean;
    includeToolTip?: boolean;
}

export function DetailsLine(props: DetailsLineProps) {
    const { detailsData, txpStyle, isFlightCardLine, isEditableEntity } = props;

    return detailsData ? (
        <div
            className={classNames({
                [txpStyle.cardDetailsDataRow]: !isFlightCardLine,
                [styles.smallText]: isFlightCardLine,
            })}>
            {detailsData.icon && (
                <Icon className={txpStyle.iconStyle} iconName={detailsData.icon} />
            )}
            <div>
                {detailsData.label && (
                    <span className={txpStyle.labelStyle}>{detailsData.label}</span>
                )}
                <span
                    className={
                        isEditableEntity && !detailsData.label
                            ? txpStyle.editableDetailsLabel
                            : null
                    }
                    title={detailsData.includeToolTip ? detailsData.text : null}>
                    {detailsData.text}
                </span>
            </div>
        </div>
    ) : null;
}
